module.exports = __webpack_public_path__ + "img/3.28962f49.png";